import { Component } from '@angular/core';
// Multi Idioma
import { TranslateService } from '@ngx-translate/core';
// Moneda
import { CurrencyPipe } from '@angular/common';
import { Router, NavigationEnd } from '@angular/router';

declare var jquery:any;
declare var $ :any;

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css']
})
export class AppComponent {
  title = 'app';

  constructor(private translate: TranslateService,private router: Router)
  {
    translate.addLangs(['en','es']);
    translate.setDefaultLang('es');
    translate.use('es');
    router.events.subscribe((evt) => {
      // Modals
      if(typeof $('.modalEnd') != 'undefined'){
        $('.modalEnd').appendTo('body');
      }
      $('#menuModal').modal('hide');
      // Scroll TOP
      if (!(evt instanceof NavigationEnd)) {
        return;
      }
      $("html, body").animate({ scrollTop: 0 }, "slow");
    });

  }
  ngOnInit()
  {

  }
}



// WEBPACK FOOTER //
// ./src/app/app.component.ts